import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import type { BaseService } from '@essent/common';
import { snakeCase, toHttpParams } from '@essent/common';
import { API_PUBLIC_PREFIX } from '@core/config-angular';
import type { Observable } from 'rxjs';
import type {
  GetReviewsQuery,
  GetReviewsResponseWithStatistics,
} from '@integration/reviews-api-models';

@Injectable()
export class ReviewsService
  implements BaseService<GetReviewsQuery, GetReviewsResponseWithStatistics>
{
  readonly apiVersion = '1';
  readonly endpoint = `${this.apiPrefix}/reviews/reviews/v${this.apiVersion}`;

  constructor(
    private readonly http: HttpClient,
    @Inject(API_PUBLIC_PREFIX) private readonly apiPrefix: string
  ) {}
  public call$({
    amountOfReviews,
    page,
    minimumScore,
    location,
  }: GetReviewsQuery): Observable<GetReviewsResponseWithStatistics> {
    const headers = {
      Accept: 'application/json',
      route: 'aws',
    };
    const params = toHttpParams(
      snakeCase({ amountOfReviews, page, minimumScore, location })
    );

    return this.http.get<GetReviewsResponseWithStatistics>(this.endpoint, {
      params,
      headers,
    });
  }
}
